import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemCollectorsRoute: InvariantJiraRoute = {
	name: 'global-settings-system-collectors',
	path: '/secure/admin/ViewGlobalCollectors([!%]?[\\w]*).jspa',
};
